var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAuth0StyleBlack = function SvgBrandAuth0StyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m18.348 19.413-2.421-7.425 6.345-4.568h-7.848L11.997.002V0h7.847l2.427 7.418.002-.001a10.71 10.71 0 0 1-3.924 11.999zm-12.696 0-.003.002L12 24l6.348-4.585-6.346-4.582zM1.73 7.417c-1.482 4.535.238 9.34 3.921 11.999v-.003l2.425-7.414-6.344-4.58h7.843L12 .001h.003-7.848z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAuth0StyleBlack);
export { ForwardRef as ReactComponent };